import { render } from "./EmailDiffResults.vue?vue&type=template&id=b75c3688"
import script from "./EmailDiffResults.vue?vue&type=script&lang=js"
export * from "./EmailDiffResults.vue?vue&type=script&lang=js"
script.render = render

export default script